module.exports = __webpack_public_path__ + "static/img/last.6952401.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/model7/last.png
// module id = clIZ
// module chunks = 3